export default __webpack_public_path__ + "static/media/bspring26.02bdd893.webp";